var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
import { mediaQuery } from '../helpers';
export function dialogStyle() {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 480px;\n\n    ", " {\n      min-width: 300px;\n    }\n  "], ["\n    max-width: 480px;\n\n    ", " {\n      min-width: 300px;\n    }\n  "])), mediaQuery.aboveSmall);
}
export function bodyStyle() {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-shadow: none;\n    overflow: hidden;\n    text-align: center;\n  "], ["\n    box-shadow: none;\n    overflow: hidden;\n    text-align: center;\n  "])));
}
export function headerStyle() {
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-align: center;\n    padding-left: 48px;\n  "], ["\n    text-align: center;\n    padding-left: 48px;\n  "])));
}
export function footerStyle() {
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    justify-content: center;\n\n    & button:first-of-type {\n      margin-right: 0;\n    }\n  "], ["\n    padding-bottom: ", ";\n    justify-content: center;\n\n    & button:first-of-type {\n      margin-right: 0;\n    }\n  "])), tokens.spacing.large);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
